import occupationActions from './occupations'
import otherOccupationActions from './otherOccupation'
import businessTypeActions from './businessType'
import otherBusinessTypeActions from './otherBusinessType'
import salaryActions from './salary'
import houseRegisterAddressActions from './houseRegisterAddress'
import currentAdressActions from './currentAdress'
import workAdressActions from './workAdress'
import documentAdressActions from './documentAdress'
import countryActions from './country'
import companyNameActions from './companyName'
import incomeActions from './income'
import objectiveActions from './objective'
import maritalStatusActions from './maritalStatus'
import childrenActions from './children'
import spouseNationalityActions from './spouseNationality'
import spouseCitizenIdActions from './spouseCitizenId'
import spouseCitizenIdExpireDateActions from './spouseCitizenIdExpireDate'
import spousePassportNoActions from './spousePassportNo'
import spousePassportNoExpireDateActions from './spousePassportNoExpireDate'
import spouseLifeLongCitizenIdActions from './spouseLifeLongCitizenId'
import spouseCountryActions from './spouseCountry'
import spouseTitleActions from './spouseTitle'
import otherTitleActions from './otherTitle'
import spouseNameActions from './spouseName'
import fristChildrenCitizenIdActions from './fristChildrenCitizenId'
import fristChildrenCitizenIdExpireDateActions from './fristChildrenCitizenIdExpireDate'
import fristChildrenCountryActions from './fristChildrenCountry'
import fristChildrenNameActions from './fristChildrenName'
import fristChildrenNationalityActions from './fristChildrenNationality'
import fristChildrenPassportNoActions from './fristChildrenPassportNo'
import fristChildrenPassportNoExpireDateActions from './fristChildrenPassportNoExpireDate'
import fristChildrenTitleActions from './fristChildrenTitle'
import secondChildrenCitizenIdActions from './secondChildrenCitizenId'
import secondChildrenCitizenIdExpireDateActions from './secondChildrenCitizenIdExpireDate'
import secondChildrenCountryActions from './secondChildrenCountry'
import secondChildrenNameActions from './secondChildrenName'
import secondChildrenNationalityActions from './secondChildrenNationality'
import secondChildrenPassportNoActions from './secondChildrenPassportNo'
import secondChildrenPassportNoExpireDateActions from './secondChildrenPassportNoExpireDate'
import secondChildrenTitleActions from './secondChildrenTitle'
import uploadDocumentActions from './uploadDocument'
import suitabilityTestScoreActions from './suitabilityTestScore'

export default {
  ...occupationActions,
  ...otherOccupationActions,
  ...businessTypeActions,
  ...otherBusinessTypeActions,
  ...salaryActions,
  ...houseRegisterAddressActions,
  ...currentAdressActions,
  ...workAdressActions,
  ...documentAdressActions,
  ...countryActions,
  ...companyNameActions,
  ...incomeActions,
  ...objectiveActions,
  ...maritalStatusActions,
  ...childrenActions,
  ...spouseNationalityActions,
  ...spouseCitizenIdActions,
  ...spouseCitizenIdExpireDateActions,
  ...spouseLifeLongCitizenIdActions,
  ...spousePassportNoActions,
  ...spousePassportNoExpireDateActions,
  ...spouseCountryActions,
  ...spouseTitleActions,
  ...otherTitleActions,
  ...spouseNameActions,
  ...fristChildrenCitizenIdActions,
  ...fristChildrenCitizenIdExpireDateActions,
  ...fristChildrenCountryActions,
  ...fristChildrenNameActions,
  ...fristChildrenNationalityActions,
  ...fristChildrenPassportNoActions,
  ...fristChildrenPassportNoExpireDateActions,
  ...fristChildrenTitleActions,
  ...secondChildrenCitizenIdActions,
  ...secondChildrenCitizenIdExpireDateActions,
  ...secondChildrenCountryActions,
  ...secondChildrenNameActions,
  ...secondChildrenNationalityActions,
  ...secondChildrenPassportNoActions,
  ...secondChildrenPassportNoExpireDateActions,
  ...secondChildrenTitleActions,
  ...uploadDocumentActions,
  ...suitabilityTestScoreActions,
}
